// extracted by css-extract-rspack-plugin
export default {"cls1":"feedback_option-cls1_PoN","cls2":"feedback_option-cls2_2i6 feedback_option-cls1_PoN","selected":"feedback_option-selected_zTf"};